import React from 'react';
import { Truck, Clock } from 'lucide-react';
/**
 * Commercial-only shipping + extended-support callout.
 *
 * Scoped deliberately to commercial mailbox systems — do NOT reuse this on
 * residential categories, since residential products do not ship free.
 *
 * Future Website Forge implementation note: a product-level free-shipping
 * field (checkbox / text) will drive a product-detail callout that renders
 * only when that field is populated. Not implemented in this design.
 */
export function CommercialShippingCallout() {
  return <section aria-label="Commercial shipping and support" className="bg-white border-b border-brand-border" data-id="element-92" data-mp="1r7idcv5l21cq">
      <div className="max-w-7xl mx-auto px-4 py-5" data-id="element-93" data-mp="1cddl4kew134t">
        <div className="bg-brand-goldWash border border-brand-gold/40 rounded-xl p-5 lg:p-6 flex flex-col lg:flex-row lg:items-center gap-5 lg:gap-8" data-id="element-94" data-mp="1h8ssqumay2ss">
          <div className="flex items-start gap-4 min-w-0 flex-1" data-id="element-95" data-mp="5uxfxsive64q">
            <div className="w-11 h-11 rounded-full bg-white text-brand-maroon flex items-center justify-center shadow-sm shrink-0" data-id="element-96" data-mp="5w8hrmsr93t7">
              <Truck size={22} strokeWidth={1.75} data-id="element-97" data-mp="1s266yo51uw7p" />
            </div>
            <div className="min-w-0" data-id="element-98" data-mp="1s40pjvsumc8m">
              <p className="font-serif text-lg font-bold text-brand-charcoal leading-snug" data-id="element-99" data-mp="261pepfty85jh">
                Free shipping on commercial mailbox systems
              </p>
              <p className="text-sm text-brand-muted leading-relaxed mt-1" data-id="element-100" data-mp="214ytyf778lrq">
                Commercial mailbox systems ship free nationwide; contact
                MidAtlantic for help confirming the right system before
                ordering.
              </p>
            </div>
          </div>

          <div className="lg:border-l lg:border-brand-gold/40 lg:pl-8 flex items-start gap-4 shrink-0" data-id="element-101" data-mp="2oujeh2j03r34">
            <div className="w-11 h-11 rounded-full bg-white text-brand-maroon flex items-center justify-center shadow-sm shrink-0" data-id="element-102" data-mp="2kt7ogvw7t3ue">
              <Clock size={22} strokeWidth={1.75} data-id="element-103" data-mp="2ts1qx2w88ofv" />
            </div>
            <div data-id="element-104" data-mp="2tpp1k4o53bss">
              <p className="text-sm font-bold text-brand-charcoal" data-id="element-105" data-mp="1redp2ub22eys">
                Extended support until 8 PM ET
              </p>
              <p className="text-sm text-brand-muted mt-0.5" data-id="element-106" data-mp="1vgigdme16zi9">
                Direct line:{' '}
                <a href="tel:240-575-5852" className="text-brand-maroon font-semibold hover:underline" data-id="element-107" data-mp="20dqxdjng0xhx">
                  240-575-5852
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}